export default "__VITE_ASSET__BOZpcxsa__"